import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import {
  deleteAllCookies,
  getCookie,
  getLoginCookie,
  hideLoader,
} from "./common/index";
import Game from "./Game";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import config from "./common/config";
// alert(process.env.REACT_APP_CHECKCOOKIE)
// let loginCookie = getLoginCookie();
// if (loginCookie?.isRegistered !== 1) {
//   deleteAllCookies();
// }
ReactDOM.render(
  <BrowserRouter>
    <Game />
  </BrowserRouter>,
  document.getElementById("root")
);

// ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
